<mat-form-field class="input-container" appearance="outline">
    <mat-label>{{ labelKey | translate }}</mat-label>
    <mat-date-range-input [rangePicker]="picker" [disabled]="isDisabled()" [required]="_isRequired()">
      <input matStartDate placeholder="Start date" #dateRangeStart [value]="value?.start" readonly>
      <input matEndDate placeholder="End date" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" [value]="value?.end" readonly>
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker" (click)="mouseInside($event)"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
@if (showError()) {
  @for (msg of errorMessages(); track msg) {
      <mat-error>{{ msg }}</mat-error>
  }
}